module.exports = __webpack_public_path__ + "img/fakepresident.51b50563.png";